export default __webpack_public_path__ + "static/media/featherJacket.c81f0f90.svg";